import useGaTracker from '../hooks/useGaTracker.js';

const GaTracker = () => {
    useGaTracker();
    return <></>;
};

export default GaTracker;
